import { useQuery } from "react-query"
import { getLeadsByID } from "api/Leads";


export const useLeadById = (id: any) => {

    return useQuery<Array<any> | any>(
        ['dashboardLeads', id],
        () => getLeadsByID({lead_id: id}),
        {
            enabled: !!id,
            onError(error: any) {
                console.error(error)
            }
        }
    )
}